import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=2941c00e&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Wallet.vue?vue&type=style&index=1&id=2941c00e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2941c00e",
  null
  
)

/* custom blocks */
import block0 from "./Wallet.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports